import { motion } from 'framer-motion'
import { MessageSquareText } from 'lucide-react'
import type { Proposta, PropostaItem } from '@/types'
import { PropostaPublicaHero } from '@/components/PropostaPublica/PropostaPublicaHero'
import { PlanScopeCard } from '@/components/PropostaPublica/PlanScopeCard'
import { ProposalInvestmentPanel } from '@/components/PropostaPublica/ProposalInvestmentPanel'
import { buildPublicPlanViews } from '@/utils/propostaPublicScope'

type Props = {
  proposta: Proposta
  empresaNome?: string
  onContratar: () => void
  canContratar: boolean
}

export function PropostaPublicaStep1({ proposta, empresaNome, onContratar, canContratar }: Props) {
  const items = (proposta.itens ?? proposta.items ?? []) as PropostaItem[]
  const plans = buildPublicPlanViews(items)

  return (
    <motion.div
      key="step1"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      className="space-y-8"
    >
      <PropostaPublicaHero />

      <div className="grid lg:grid-cols-[minmax(0,1fr)_320px] gap-6 items-start">
        <div className="space-y-6 min-w-0">
          {plans.length > 0 ? (
            plans.map((plan, idx) => <PlanScopeCard key={plan.item.id} plan={plan} index={idx} />)
          ) : (
            <div className="rounded-2xl border border-dashed border-[var(--border)] p-8 text-center bg-[var(--bg-card)]">
              <p className="text-sm text-[var(--text-muted)]">
                Nenhum item detalhado nesta proposta.
              </p>
            </div>
          )}

          {proposta.observacoes && (
            <div className="lg:hidden rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] p-5 shadow-sm">
              <div className="flex items-center gap-2 mb-2">
                <MessageSquareText size={15} className="text-[var(--brand-primary)]" />
                <h3 className="text-xs font-bold uppercase tracking-wider text-[var(--text-muted)]">
                  Observações gerais
                </h3>
              </div>
              <p className="text-sm text-[var(--text-primary)] whitespace-pre-line leading-relaxed">
                {proposta.observacoes}
              </p>
            </div>
          )}
        </div>

        <ProposalInvestmentPanel
          proposta={proposta}
          items={items}
          empresaNome={empresaNome}
          onContratar={onContratar}
          canContratar={canContratar}
        />
      </div>
    </motion.div>
  )
}
